<template>
	<div class="solve">
		<div class="solonlogy-top">
			<img src="../../static/img/solve.jpg"/>
			<div class="bannerMask"><div></div></div>

			<div class="com-tit">
				<span>
					<img src="../../static/img/solveicon.png"/><b>解决方案</b>
				</span>
				<p>以信息化技术为基础，深入行业需求，服务于各行业，提供相<br />
关行业的专业解决方案</p>
			</div>
		</div>
		<div class="case-nav">
			
		</div>
		<div class="sol-detail">
			<div class="sol-top-top">
				<!-- <h4>{{sol[chalid].title}}</h4>
				<div class="sol-line">
					
				</div> -->
				<ul>
					<li v-for="navli in navli" class="casenav" v-bind:class="{caseacli : chalid == navli.id}" @click="seltab(navli.id)">{{navli.litit}}</li>
				</ul>
			</div>
			<!---->
			<div class="solinfo" v-if="chalid == 0 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content">   新零售，即企业以互联网为依托，通过运用大数据、人工智能等先进技术手段，对商品的生产、流通与销售过程进行升级改造，进而重塑业态结构与生态圈，并对线上服务、线下体验以及现代物流进行深度融合的零售新模式。</p> 
					<p class="com-content">   新零售系统采用线上线下互通理念，线上平台为消费者提供消费指南、优惠信息、便利服务（预订、在线支付、地图等）和分享平台，而线下门店则专注于提供商品展示/体验、下单、提货等服务。线上线下一体化可以充分实现品牌传播、流量的存与增、信息互通、资源互动，可以更大程度的提升竞争力，更好的服务用户。根据新零售系统销在消费者下单购买后，可以快速送达消费者手中。不但发货速度快、产品质量有保障，还提供线下门店体验及退换货售后服务，彻底解决了海淘带来的弊病。	</p>
					<p class="com-content">   新零售系统将新零售总结为“线上+线下+物流，其核心是以消费者为中心的会员、支付、库存、服务等方面数据的全面打通。 </p>
					<h4 class="small-tit">{{xls[0].smalltit}}</h4>
					<center><img src="../../static/img/xls2.png"></center>
					<p style="color: #C9302C;">1、精细化解决零售运营难题</p>
					<p>打破空间局限，提高门店坪效: 以门店为服务圆点，融合线上，构建立体服务网络线上线下互补营运，打造最佳消费者体验。</p>
					<p>告别混乱管理，打通进销存: 打通线上线下多渠道销售实时洞悉准确库存缺货自动提醒，采购补货一键完成，销售端库存自动更新。</p>
					<p>用数据驱动门店管理: 实时掌握门店业绩走势监控业绩达成、客单价、退货率等经营指标</p>
					<p style="color: #C9302C;">2、沉淀数据，高效管理会员</p>
					<p>全方位采集消费者数据: 充分利用线下门店流量，将到店顾客转化为线上会员。</p>
					<p>线上线下一套会员数据: 无障碍识别会员身份，打通会员、积分、资产、全渠道会员管理。</p>
					<p>精细化管理会员: 社交化会员管理系统、会员卡、积分体系，会员标签、购买力筛选，数据指导二次营销</p>
					<p style="color: #C9302C;">3、快速搭建全渠道零售体系</p>
					<p>为客户输出整体方案: 用一套方案搭建全渠道零售体系拒绝多个业务系统相互割裂而造成的“信息孤岛”。</p>
					<p>省去多套系统购买、对接成本: 大幅降低使用多套系统的购买成本、对接成本以及与供应商的沟通成本。</p>
					<p>兼容加盟、直营两套体系: 区域价格管理，自动结算平台统一管控营销策略，灵活设定营销政策。</p>
					<h4 class="small-tit">{{xls[1].smalltit}}</h4>
					<p>面向线下实体门店，满足零售店铺线上线下协同运营的诉求</p>
					<center><img src="../../static/img/xls.png" style="margin-top: 30px;"></center>
            </div>
			<!---->
			<div class="solinfo" v-if="chalid == 1 ">
					<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content"> 就是利用云计算，物联网等新技术，通过互联网/移动互联网，借助便携的终端上网设备，主动感知旅游资源、旅游经济、旅游活动、旅游者等方面的信息，及时发布，让人们 能够更及时了解这些信息，及时安排和调整工作与旅游计划，从而达到对各类旅游信息的智能感知、方便利用的效果。
      “智慧旅游”的推广，将提升游客在食、住、行、游、购、娱每个旅游消费环节中的附加值；旅游者在旅游前、旅游中、旅游后，都能够轻松地获取资讯、规划出行、预订票务、安排食宿、消费支出等 ，极大改善旅游体验。</p> 
					<h4 class="small-tit">{{solimg[0].smalltit}}</h4>
					<div class="sol-singleimg">
						<img :src="solimg[0].imgsrc" style="margin-bottom: 20px;">
					</div>
					<p>根据行业的分析，我们从“旅游服务”、“旅游管理”和“旅游营销”这三大方面，通过对顾客、主办单位及景区管理各不同角色的需求分析，形成智慧旅游整体解决方案的构思。
					</p> 
					<div class="sol-singleimg">
						<img :src="solimg[1].imgsrc" style="margin-bottom: 20px;">
					</div>
					<p><b>基础层</b> 用于支持各信息系统的安全运行及数据交换的各种必要信息化基础设施，包括网络通讯设施、网络信息安全系统和各种基础软件平台。 </p>
					<p><b>应用层</b>分为应用支撑层和用户应用层 应用支撑层主要是一些基础信息系统，通过系统的建设提供功能和数据上的支持；用户应用层则主要面向用户提供特定的功能和用户界面的层现形式。</p>
					<p><b>指挥层 </b>实现景区管监控指挥中心工作的协同联动，指挥调度中心集中设置视频、GPS监控指挥、接处境等系统、利用电视墙、大屏幕设备，接入显示各监控点的视频，并可利用多个大屏幕同时放大显示 重要位置的视频和GPS监控电子地图等，一旦发生紧急事件，工作人员可更充分了解现场状况、迅速找出最佳措施，并及时向相关职能部门发出指令，快速处理 </p>
					<p><b>数据层 </b>数据中心建设专用数据中心机房，采用具备千兆网络接口的应用服务器和数据库服务器，并设立专门的计算机系统维护机构和人员，主要承载门户网站、电子商务和业务审批三大应用，实现网上业务流程及各种业务应用，并集中管理和整合核心业务数据。 </p>
					<h4 class="small-tit">{{solimg[1].smalltit}}</h4>
					<div class="sol-singleimg">
						<img :src="solimg[2].imgsrc" style="width: 60%;margin-top: 30px;">
					</div>
            </div>
            <!---->
            <div class="solinfo" v-if="chalid == 2 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content">   “智慧法院”是人民法院信息化建设转型升级的产物，以信息化推进人民法院审判体系和审判能力现代化 ，服务国家治理体系和治理能力现代化。积极适应信息科技发展和“互联网+”时代要求，创新机制，充分运用大数据，推进“智慧法院”建设，方便人民群众诉讼，服务经济社会发展，努力让人民群众在 每一个司法案件中感受到公平正义。</p> 					   
					<div class="sol-singleimg">
						<img :src="fayuan[0].imgsrc" style="width: 50%;margin-top: 10px; margin-bottom: 20px;">
					</div>
					<p>智慧法院行业解决方案，将涉及各个角色（如诉讼人、律师、法官及法院内部管理者）的关系，整合成一个角色划分 鲜明的整体，以人为本，科技为手段，体现智能化，对外提高办案效率，对内形成系统化的管理。其中包含三大模块：<b>专业业务系统、数据中心、基础运营平台</b>。
					</p> 
					<div class="sol-singleimg">
						<img :src="fayuan[1].imgsrc" style="width: 50%; margin-top: 20px;">
					</div>
            </div>
             <!---->
             <div class="solinfo" v-if="chalid == 3 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content">  为更大限度地激活市场要素，整合资源，加强市场监管、降低交易成本，最大限度地在公共资源交易中体现公开、公平、公正，从源头上预防和治理腐败。建立统一公共 资源交易平台，创新管理手段，负责行使招标投标及竞拍工作的具体实施、行政监督和管理职能。</p> 					   
					<h4 class="small-tit">{{ggzy[0].smalltit}}</h4>
					<div class="sol-singleimg">
						<img :src="ggzy[0].imgsrc"/>
					</div>
					<h4 class="small-tit">{{ggzy[1].smalltit}}</h4>
					<div class="sol-singleimg">
						<img :src="ggzy[1].imgsrc"/>
					</div>
					<p>该平台有公共服务、项目交易、综合管理三大基础系统组成;通过“云计算”、“云技术”的应用，服务于如政府采购、工程建设等多类型行业业务；形成的相关业务数据，通过数据中心的建设，实现数据的采集 、分析等功能；最终达到对外提高公共资源交易服务的效率，对内满足公共资源服务单位规范化、系统化管理的双重目的。
					</p> 
					<h4 class="small-tit">{{ggzy[2].smalltit}}</h4>
					<p class="ggzyp" v-for="item in ggzyp">{{item.tit}}</p>
            </div>
            <!---->
            <div class="solinfo" v-if="chalid == 4 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content">作为我司自主研发的产品，旨在满足律师行业的业务需求，提供更畅快的办公体验、更有效的管理模式、以及更智能的业务员流程。</p> 					   
					<h4 class="small-tit">{{zhls[0].smalltit}}</h4>
					<div class="sol-singleimg">
						<img :src="zhls[0].imgsrc" style="width: 50%"/>
					</div>
					<h4 class="small-tit">{{zhls[1].smalltit}}</h4>
					<div class="sol-singleimg">
						<img :src="zhls[1].imgsrc" style="width: 50%"/>
					</div>
					<div class="sol-singleimg">
						<img :src="zhls[2].imgsrc" style="width: 50%"/>
					</div>
					<h4 class="small-tit">{{zhls[2].smalltit}}</h4>
					<p> 通过电脑PC端和手机微信端相结合的应用，从功能上实现行业办公、管理及业务办理的快捷、有效和智能化需求特点。
					</p>
					<div class="sol-singleimg">
						<img :src="zhls[3].imgsrc" style="width: 50%"/>
					</div>
            </div>
			<!-- 智慧校园 -->
			<div class="solinfo" v-if="chalid == 5 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content">  “智慧校园”系统，对于优质资源学校推进建设智慧校园系统以及在班级建设智慧班级，多媒体教室系统，形成面向学校管理者、教师、学生、家长的绿色、开放、共享和可持续的个性化服务，并进一步促进学校管理水平的提升，促进师生健康发展和家校良好沟通，为信息技术与教育教学融合创造新环境和新机制。
智慧校园将配套实验性建立智能教学辅助支持系统，通过收集教学过程中根据作业、测验、考试等各项学习数据进行AI数据分析，针对不同学生出具不同评估报告，用于教师辅助决策，综合素质评定等等；同时教师可以利用知识导图体系，运用精准推送等系统工具为学生群体和个人提供个性化辅助教学，从而有效提高学生成绩。
					</p> 
					<p>通过前瞻性、系统性、兼具可实施性的设计理念，充分发挥教育信息化对教育现代化的支撑和引领作用，借助云计算、大数据、移动互联网、人工智能等先进技术，规划全区高水平的智慧教育信息化基础设施；打造“智慧校园”、区域共享平台等信息化设施体系；搭建具有本地特色，实现教学资源优势互补，线上线下多样化教学方式，高效、适用易用的区域信息化支撑体系。
					</p>
					<center ><img style="width:50%" src="../../static/img/zhxy01.png" ></center>
					<p>智慧校园”系统，对于优质资源学校推进建设智慧校园系统以及在班级建设智慧班级，多媒体教室系统，形成面向学校管理者、教师、学生、家长的绿色、开放、共享和可持续的个性化服务，并进一步促进学校管理水平的提升，促进师生健康发展和家校良好沟通，为信息技术与教育教学融合创造新环境和新机制。
智慧校园将配套实验性建立智能教学辅助支持系统，通过收集教学过程中根据作业、测验、考试等各项学习数据进行AI数据分析，针对不同学生出具不同评估报告，用于教师辅助决策，综合素质评定等等；同时教师可以利用知识导图体系，运用精准推送等系统工具为学生群体和个人提供个性化辅助教学，从而有效提高学生成绩。
					</p>
            </div>
			<!-- 智慧工厂 -->
			<div class="solinfo" v-if="chalid == 6 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
					<p class="com-content">
						厂区作为现代化办公、生产、研发，将主要用作业务、科研、行政办公以及生产基地等。在信息知识经济的时代，业主欲将厂区建设成为具有智能型特征，高科技科研生产基地。我们从智能建筑的四大要素（即结构、系统、服务和管理）来理解、分析厂区智能化的需求。
					</p> 
					<center ><img style="width:50%" src="../../static/img/zhgc01.png" ></center>
					<p>
						拟建设成为具有国内外先进水平的，符合高科技生产基地的智能化办公、生产区。智能化系统包含以下特点：
					</p>
					
					<p>
						<span style="color: rgb(201, 48, 44);">1、高效：</span>
						将建筑的结构、系统、服务、管理四个基本要素进行优化组合，提供一个投资合理，具有安全、舒适、快捷的服务、科研、办公环境，从而提高工作效率；
					</p>
					<p>
						<span style="color: rgb(201, 48, 44);">2、节能：</span>	
						通过现代化科技监视、控制手段，采用计算机网络对楼宇机电设备及其系统进行最佳控制，大幅度降低楼宇设备系统的运行、维护、管理成本，达到有效延长以及合理利用能源的目的；
					</p>
					<p>
						<span style="color: rgb(201, 48, 44);">3、科学管理：</span>
						建设厂区通讯自动化和办公自动化系统，为服务、科研、办公的管理手段创造一个优越的环境，并为正常的生产提供优质环境；
					</p>
					<p>
						<span style="color: rgb(201, 48, 44);">4、降低管理成本：</span>
						建立起集中监控、人机界面、信息共享基础上的综合管理模式，从而实现减少维护管理人员，各系统信息显示集中、直观、降低运行成本，建设一个支持厂区内设备监控自动化、安全防范自动化、网络通信自动化的先进的、开放的平台。
					</p>
            </div>
			<!-- 立体化社会防范体系平台 -->
			<div class="solinfo" v-if="chalid == 7 ">
            	<h4 class="small-tit">{{sol[chalid].smalltit}}</h4>
				<p class="com-content">
					立体化社会防范体系平台通过互联网、网络平台、云平台等先进信息技术的支持，为广大群众提供了一种快速、高效的报警方式。警务人员通过综合服务平台实时监控报警情况，做到实时收取信息，及时做出响应。
				</p> 
				<h4 class="small-tit">系统架构</h4>
				<center ><img style="width:50%" src="../../static/img/lth01.png" ></center>
				<h4 class="small-tit">业务流程展示图</h4>
				<center ><img style="width:50%" src="../../static/img/lth02.png" ></center>
				<h4 class="small-tit">建设特点</h4>
				<p style="color: rgb(201, 48, 44);">1、警情与110实时互通</p>
				<p style="color: rgb(201, 48, 44);">2、社会视频接入公安视频平台</p>
				<p>云平台技术的应用，使得整体平台适用于当前治安工作分散、紧急性、实时性的特点</p>
            </div>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'solve',
		data () {
			return {
				sol : [
				{id : 0 , imgsrc : 'static/img/solve.jpg' , title : '新零售' , smalltit : '新零售'},
				{id : 1 , imgsrc : 'static/img/solve.jpg' , title : '智慧旅游' , smalltit : '智慧旅游'},
				{id : 2 , imgsrc : 'static/img/solve.jpg' , title : '智慧法院' , smalltit : '智慧法院'},
				{id : 3 , imgsrc : 'static/img/solve.jpg' , title : '公共资源交易一体化' , smalltit : '公共资源交易一体化'},
				{id : 4 , imgsrc : 'static/img/solve.jpg' , title : '律师行业业务综合管理系统' , smalltit : '律师行业业务综合管理系统'},
				{id : 5 , imgsrc : 'static/img/solve.jpg' , title : '智慧校园' , smalltit : '智慧校园'},
				{id : 6 , imgsrc : 'static/img/solve.jpg' , title : '智慧工厂' , smalltit : '智慧工厂'},
				{id : 7 , imgsrc : 'static/img/solve.jpg' , title : '立体化社会防范体系平台' ,smalltit : '立体化社会防范体系平台'},
				],
				solimg : [
				{id : 0 , imgsrc : 'static/img/sc-lvyou-1.png' , smalltit : '需求分析'},
				{id : 1 , imgsrc : 'static/img/zhihuilvyou.png' , smalltit : '建设目标特点'},
				{id : 2 , imgsrc : 'static/img/zhihuitedian.png' , smalltit : ''},
				],
				xls : [
				{id : 0 ,  smalltit : '系统特点'},
				{id : 1 ,  smalltit : '系统应用场景'},
				],
				yewu :[
				{id : 0, imgsrc : 'static/img/yewumodx.png' , smalltit : '项目建设'},
				{id : 1, imgsrc : 'static/img/yewumodp.png' , smalltit : '产品开发'},
				{id : 2, imgsrc : 'static/img/yewumodz.png' , smalltit : '项目合作运营'},
				],
				chalid : 0,
				fayuan :[
				{id : 0 , imgsrc : 'static/img/zhfy.jpg'},
				{id : 1 , imgsrc : 'static/img/zhfy2.jpg'},
				],
				ggzy : [
				{id : 0 , imgsrc : 'static/img/ggzy1.png' , smalltit : '建设目标关键点'},
				{id : 1 , imgsrc : 'static/img/ggzy2.png' , smalltit : '平台架构图'},
				{id : 2 , imgsrc : 'static/img/ggzy2.png' , smalltit : '公共资源网上交易系统建设'},
				],
				ggzyp : [
				{id : 0 , tit : '1.公共资源网上交易大厅（门户网站）'},
				{id : 1 , tit : '6.政府采购交易招投标系统'},
				{id : 2 , tit : '2.手机APP客户端'},
				{id : 3 , tit : '7.公共资源和综合管理系统'},
				{id : 4 , tit : '3.土地与矿业网上交易系统'},
				{id : 5 , tit : '8.专家申报与管理系统'},
				{id : 6 , tit : '4.产权网上交易竞价系统'},
				{id : 7 , tit : '9.办公OA系统'},
				{id : 8 , tit : '5.建设工程交易招投标系统'},
				{id : 9 , tit : '10.交易监察系统'},
				],
				zhls : [
				{id : 0 , imgsrc : 'static/img/lvshihangye.jpg' , smalltit : '专业解决方案'},
				{id : 1 , imgsrc : 'static/img/zhls2.png' , smalltit : '系统架构'},
				{id : 2 , imgsrc : 'static/img/zhls3.png' , smalltit : '功能特点'},
				{id : 3 , imgsrc : 'static/img/zhls4.png' , smalltit : '功能特点'},
				],
				navli : [
				{id : 0 , litit : '新零售'},
				{id : 1 , litit : '智慧旅游'},
				{id : 2 , litit : '智慧法院'},
				{id : 5 , litit : '智慧校园'},
				{id : 6 , litit : '智慧工厂'},
				{id : 3 , litit : '公共资源交易'},
				{id : 4 , litit : '律师行业业务'},
				{id : 7 , litit : '立体化社会防范'},
				],
			}
		},
		mounted(){
			this.getID()
			//console.log(this.chalid)
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
			seltab(index){
				this.chalid = index
			}
		},
	}
</script>

<style>
	.solve{
		width: 100%;
		position: relative;
		clear: both;
		overflow: hidden;
	}
	.sol-detail{
		width: 80%;
		margin: 27px auto 60px;
		position: relative;
		clear: both;
		text-align: left;		
	}
	.sol-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}	
		.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.sol-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
	}
	.sol-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}	
	.solonlogy-top {
		margin-top: -3vw;
	}
	.solonlogy-top img{
		width: 100%;
	}
	.solinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.solinfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.solinfo img{
		text-align: center;
	}
	.sol-singleimg{
		text-align: center;
		position: relative;
	}
	.sol-singleimg img{
		
	}
	.sol-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 50px auto 0;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
		margin-bottom: 30px;
	}
	.solinfo p b{
		color: red;
	}
	.solinfo p.ggzyp{
		display: inline-block;
		width: 49%;
		position: relative;
		clear: both;
		margin: 10px 0;
	}

	.solve .sol-top-top{
		width: 100%;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 0px;
		border-bottom: none;
		margin-top: -3vw;
	}
	.sol-top-top li.casenav{
		display: inline-block;
		width: 12%;
		padding: 10px;
		background: #FFFFFF;
		margin-right: 2px;
		color: #666;
		transition: .2s all;
		font-size: 16px;
		cursor: pointer; 
		user-select: none;
	}
	
	.sol-top-top li.casenav:hover{
	    transform: scale(1.05);
	    background: #C5DAE6 !important;
	    color: #008EE2 !important;
	}
	
	.sol-top-top li.caseacli{
		color: #fff;
    	background: #1d8ce0;
	}
	.solve .sol-top-top ul{
		width: 100%;
		margin: 0 auto;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/solve.vue